import routerOptions0 from "/home/zebrafashion/zebrafashion.com/releases/75947690/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  linkActiveClass: "link-active",
  linkExactActiveClass: "link-exact-active text-primary",
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}